import React, { useState } from "react";
import "./ToggelSwitch.css";

const ToggleSwitch = ({ onChange, checked }) => {
  // const [checked, setChecked] = useState(false);

  // const handleChange = () => {
  //   const newValue = !checked;
  //   // setChecked(newValue);
  //   onChange(newValue);
  // };

  return (
    <label className="toggle-switch">
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="slider"></span>
    </label>
  );
};

export default ToggleSwitch;